"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pills = void 0;
const react_1 = __importStar(require("react"));
const Pills_styles_1 = require("./Pills.styles");
const Pills = ({ label, items, defaultSelection, onChange }) => {
    const [valueState, setValueState] = (0, react_1.useState)(defaultSelection);
    return (react_1.default.createElement(Pills_styles_1.PillsComponentWrapper, null,
        label && react_1.default.createElement(Pills_styles_1.Label, null, label),
        react_1.default.createElement(Pills_styles_1.PillsWrapper, null, items.map(({ value, label, icon }) => {
            const Icon = icon;
            return (react_1.default.createElement(react_1.default.Fragment, { key: value },
                react_1.default.createElement(Pills_styles_1.Input, { id: value, value: value, type: "radio", checked: value === valueState, onChange: () => {
                        setValueState(value);
                        onChange(value);
                    } }),
                react_1.default.createElement(Pills_styles_1.ContentContainer, { htmlFor: value },
                    react_1.default.createElement(Pills_styles_1.IconContainer, null, Icon && react_1.default.createElement(Icon, null)),
                    react_1.default.createElement(Pills_styles_1.Content, null, label))));
        }))));
};
exports.Pills = Pills;
//# sourceMappingURL=Pills.js.map